import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { ForskerService } from 'src/app/services/forsker-chat.service';

@Component({
  selector: 'app-forsker',
  templateUrl: './forsker.component.html',
  styleUrls: ['./forsker.component.scss']
})
export class ForskerComponent implements OnInit {


  constructor(private forskerService: ForskerService, public userService: UserService,) { }

  processing: boolean = false;
  date: Date = new Date()
  chatResponses: any[] = [
  ]
  inputValue: string = '';

  onSubmit() {
    console.log(this.inputValue);
  }

  get photo() {
    return this.userService.currentUser?.photo
      ? this.userService.currentUser?.photo
      : 'assets/images/user.png';
  }

  ngOnInit() {
    this.chatResponses.push({ text: "¡Bienvenido!", sender: 'bot' })
    this.processing = true
    setTimeout(() => {
      this.processing = false
      this.chatResponses.push({ text: "¡Soy Forsker! Asistente de Analytiko ¿En que puedo ayudarte?", sender: 'bot' })
    }, 3000)
  }

  sendMessage() {
    this.chatResponses.push({ text: this.inputValue, sender: 'user' });
    this.processing = true;
    this.forskerService.post(this.inputValue).subscribe((res: any) => {
      this.processing = false;
      res.Sources.map((source) => {
        try {
          const decoder = new TextDecoder('utf-8');
          const decodedSource = decoder.decode(new Uint8Array(source[1]));
          return JSON.parse(decodedSource);
        } catch (e) {
          return source[1];
        }
      })
      console.log(res)
      console.log(res.Sources)
      const contexts = []
      for (let source of res.Sources) contexts.push(`From file: ${source[0]}...<br>Text: ${source[1]}`)
      this.chatResponses.push({ text: res.Answer, sender: 'bot', context: contexts.join('<br><br>'), showMore: false });
      setTimeout(() => { this.goToBottom() }, 1000)
    }, (err) => {
      this.processing = false;
      console.log(err)
      this.chatResponses.push({ text: "Lo siento, estoy procesando otra pregunta, puedes reitentar en unos segundos...", sender: 'bot' })
    })
    this.inputValue = '';
  }

  goToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }
}
